import { useQuery } from "@tanstack/react-query";
import type { CanaryListView } from "@shared/types/canary";

/** `GET /api/v2/platform/canary` (#826): each canary tenant and its newest results. */
export const CANARY_PATH = "/api/v2/platform/canary";
export const CANARY_KEY = [CANARY_PATH] as const;

export function useCanaries(enabled = true) {
  return useQuery<CanaryListView>({ queryKey: CANARY_KEY, enabled });
}
